import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';

/**
 * Colonna di una `Table`.
 */
function HeaderColumn({ children, width }) {
    const style = useMemo(() => (width ? { width } : undefined), [width]);
    return (jsx("th", { style: style, children: children }));
}
HeaderColumn.defaultProps = {
    children: null,
    width: null,
};

export { HeaderColumn as default };
